import * as yup from "yup";

const validationSchema = yup.object().shape({
  brand_description: yup.string().required("Required").max(350, "Max. 350"),
});

export default validationSchema;
